import { render, staticRenderFns } from "./batch-form-pm-no-tag.vue?vue&type=template&id=499f3fde&"
import script from "./batch-form-pm-no-tag.vue?vue&type=script&lang=js&"
export * from "./batch-form-pm-no-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports